import './finished-events.scss';
import './partials/_swiper';
